/** One choice of the entity type picker: the stored value and its label. */
export interface EntityType {
  value: string;
  label: string;
}

/**
 * The entity types a login can set up, shared by the create form and the
 * client page's edit form so both show the same choices (gate 2 Risk M9).
 * "personal" is 5d's personal books (LF-126), sent with the personal chart.
 */
export const ENTITY_TYPES: EntityType[] = [
  { value: "general", label: "General" },
  { value: "sole_proprietor", label: "Sole proprietor" },
  { value: "llc", label: "LLC" },
  { value: "s_corp", label: "S-Corp" },
  { value: "c_corp", label: "C-Corp" },
  { value: "partnership", label: "Partnership" },
  { value: "nonprofit", label: "Nonprofit" },
  { value: "personal", label: "Personal books (not a business)" },
];
